import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const workspaceRateLimitsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("workspace-rate-limits-nro-heading", "Workspace Rate Limit Settings"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("rate_limit_pricing_model_entitlement") &&
      hasPermission("company", {
        permission: "admin",
      })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/admin_settings/workspace_rate_limits/:appGroupId",
};
